(function(konto) {
	konto.uz = {};
} (konto = window.konto));
